// test2616
(2616 && 0);
